export type ProductId = "services" | "business" | "deals";

export const productLinks: Record<ProductId, string> = {
  services:
    import.meta.env.VITE_SERVICES_URL || "https://app.stratifyservice.com",
  business:
    import.meta.env.VITE_BUSINESS_URL || "https://business.stratifyservice.com",
  deals: import.meta.env.VITE_DEALS_URL || "https://stratifydeals.com",
};

export const products = [
  {
    id: "services" as const,
    name: "Stratify Services",
    shortName: "Services",
    audience: "For customers",
    title: "Book professionals and event tickets.",
    description:
      "Compare service packages and professional profiles before you book. Message a professional, track your booking, or buy event tickets.",
    features: [
      "Compare listings and packages",
      "Message professionals",
      "Book services and event tickets",
    ],
    action: "Browse services",
    summary: "Book services and event tickets",
    photo: "/assets/landing/salon.webp",
    photoAlt: "A stylist talking a client through options at a salon counter",
  },
  {
    id: "business" as const,
    name: "Stratify Business",
    shortName: "Business",
    audience: "For businesses",
    title: "Manage your services and events.",
    description:
      "Manage service listings, bookings, and event tickets in Stratify Business. Invite team members and choose what each person can access.",
    features: [
      "Service and event workspaces",
      "Listings, bookings and ticketing",
      "Team invitations and roles",
    ],
    action: "Open Stratify Business",
    summary: "Manage bookings, events and your team",
    photo: "/assets/landing/shop-counter.webp",
    photoAlt: "A shop owner serving a customer at the counter",
  },
  {
    id: "deals" as const,
    name: "Stratify Deals",
    shortName: "Deals",
    audience: "For food shoppers",
    title: "Buy surplus food from local shops.",
    description:
      "Browse surplus meals, pastries, and groceries from local businesses. Check the price and pickup window, pay online, and collect your order.",
    features: [
      "See prices, savings and availability",
      "Add to cart and pay online",
      "Collect during the pickup window",
    ],
    action: "Browse food deals",
    summary: "Buy surplus food for local pickup",
    photo: "/assets/landing/bread.webp",
    photoAlt: "Freshly baked seeded loaves on a bakery counter",
  },
];
